"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AppointmentStatusChangeRequestSchema () {
        return AppointmentStatusChangeRequestSchema;
    },
    get AppointmentStatusChangeResponseSchema () {
        return AppointmentStatusChangeResponseSchema;
    }
});
const _zod = require("zod");
const _appointmentcancellation = require("./appointment-cancellation");
const _appointmentstatus = require("./appointment-status");
const AppointmentStatusChangeRequestSchema = _zod.z.object({
    status: _appointmentstatus.AppointmentStatusSchema,
    expectedStatus: _appointmentstatus.AppointmentStatusSchema,
    cancellation: _appointmentcancellation.AppointmentCancellationSchema.optional()
}).strict().superRefine((request, ctx)=>{
    if (request.status === 'cancelled' && request.cancellation === undefined) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'cancellation'
            ],
            message: 'A cancellation reason is required to cancel an appointment.'
        });
    }
    if (request.status !== 'cancelled' && request.cancellation !== undefined) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'cancellation'
            ],
            message: 'A cancellation reason is only allowed when cancelling an appointment.'
        });
    }
});
const AppointmentStatusChangeResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    status: _appointmentstatus.AppointmentStatusSchema,
    statusChangedAt: _zod.z.string().datetime({
        offset: true
    })
});
